module.exports = __webpack_public_path__ + "img/mockup_benefit3@2x.9b42e705.png";